import { ZodNullableDef } from "zod";
import {
  defaultEventFilters,
  EventListRequestParams,
} from "../forms/filters/event";
import {
  BoolResponce,
  EventCardInfo,
  EventData,
  EventFullData,
  LibItem,
  UserPersonalData,
  UserPhoto,
  UserShortInfo,
} from "../types";
import BackendConnect from "./connect";

export interface Notification {
  id: number;
  date: number;
  title: string;
  description?: string;
  url?: string;
  label: number;
  category: number;
  user_id?: number;
  group_id?: number;
  read?: boolean;
}

export interface NotificationFilters {
  id?: number;
  date_min?: number;
  date_max?: number;
  title?: string;
  description?: string;
  url?: string;
  label?: number;
  category?: number;
  user_id?: number;
  group_id?: number;
  is_read?: boolean;
}

export const READ_DATE_STORAGE_KEY = "lastRead";
export const READ_LIST_STORAGE_KEY = "readNotify";

export class BackendUserService extends BackendConnect {
  protected static instance: BackendUserService;

  constructor(headers: Record<string, string>) {
    super(headers);
  }

  static getInstance(): BackendUserService {
    if (!BackendUserService.instance) {
      BackendUserService.instance = new BackendUserService({});
      const bearerToken = localStorage.getItem("bearerToken");
      if (bearerToken) {
        BackendUserService.instance.setAccessToken(bearerToken);
      }
    }
    return BackendUserService.instance;
  }

  public async createUser(
    userData: {
      firstName?: string;
      lastName?: string;
      phone: string;
      internalId: string;
    },
    code: number
  ): Promise<{ id: number } | null> {
    return this.post("/user/create", { user: userData, code });
  }

  public async userShortInfo(userid: number): Promise<{ user: UserShortInfo }> {
    return this.get(`/user/short/${userid}`);
  }

  public async getAllUsersCount(): Promise<{ count: number }> {
    return this.get("/lists/user/count");
  }

  public async getUserProfile(
    userId: number
  ): Promise<{ data: UserPersonalData } | null> {
    return this.get(`/user/profile/${userId}`);
  }

  public async getUserFiles(userId: number): Promise<{ files: UserPhoto[] }> {
    return this.get(`/user/files/${userId}`);
  }

  public async updateUserProfile(data: UserPersonalData): Promise<boolean> {
    return this.post("/profile/update", data, "POST");
  }

  public async loadUserPhoto(file: File): Promise<{ file: number | null }> {
    return this.file("/uploadphoto", {}, file);
  }

  public async loadUserDocument(file: File): Promise<{ file: number | null }> {
    return this.file("/uploaddocument", {}, file);
  }

  // Notifications

  public async getNotifications (filters: NotificationFilters = {}): Promise<{list: Notification[]}> {
    return this.get("/user/notifications", {...filters})
  }

  public async getNotificationCount (filters: NotificationFilters = {}): Promise<{count: number | null}> {
    return this.get("/user/notifycount", {...filters})
  }

  public async readNotification (notify_id: number): Promise<BoolResponce> {
    localStorage.setItem(READ_DATE_STORAGE_KEY, new Date().getTime().toString());
    return this.get(`/user/notify/read/${notify_id}`);
  }
  
  public async updateUserPassword (newPassword: string, userid: number): Promise<BoolResponce> {
    return this.post("/auth/setnewpassword", { newPassword, userid }, "POST");
  }

}

export const userBackend = BackendUserService.getInstance();
